import styled from 'styled-components';

// Components
import { Link } from 'react-router-dom';
import * as S from '../LangSwitcher/Styled';
import Obfuscate from 'react-obfuscate';

export const Footer = styled.footer.attrs(() => ({
  className: 'footer',
}))`
  height: 178px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--white);

  @media (max-width: 920px) {
    padding: 16px 18px;
    height: auto;

    ${S.Switcher} {
      display: none;
    }
  }

  @media (max-width: 899px) {
    padding: 16px 18px;
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;

  @media (max-width: 920px) {
    display: flex;
    flex-direction: column;
  }
`;

export const Copyright = styled.div`
  font-size: 16px;
  color: var(--grey70);

  @media (max-width: 900px) {
    margin-bottom: 0;
    line-height: 1;
    text-align: center;
  }
`;

export const MenuOuter = styled.div`
  margin-bottom: 29px;
  display: none;

  @media (max-width: 900px) {
    margin-left: 0;
    margin-bottom: -1px;

    &:after {
      content: '';
      width: 60px;
      height: 1px;
      display: block;
      background: var(--aluminium60);
      margin: 15px auto 26px;
    }
  }

  @media (min-width: 768px) {
    display: block;
  }

  @media (min-width: 921px) {
    margin-bottom: 29px;
    align-self: center;
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 920px) {
    flex-direction: column;
  }

  @media (min-width: 920px) and (max-width: 900px) {
    padding-bottom: 29px;
  }

  @media (max-width: 900px) {
    padding-bottom: 0;
  }
`;

export const Contacts = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 920px) {
    text-align: center;
    flex-direction: column;
  }
`;

export const ContactItem = styled.div`
  text-align: right;

  @media (max-width: 920px) {
    margin: 4px 0;
    text-align: center;
    font-size: 12px;
    line-height: 1.3em;

    br:nth-last-child(1) {
      display: none;
    }
  }
`;

export const Phone = styled.a`
  color: var(--grey100);
  font-size: 18px;
  font-weight: 600;
  transition: var(--transition);
  margin-left: 0.5rem;
  margin-right: 0.5rem;

  @media (max-width: 920px) {
    display: block;
  }
`;

export const Email = styled(Obfuscate)`
  margin-left: 40px;
  font-size: 14px;
  line-height: 1.8em;
  color: var(--blue100);
  transition: var(--transition);

  &:hover {
    color: var(--blue120);
  }

  @media (max-width: 920px) {
    margin-left: 0;
  }
`;

export const Social = styled.div`
  margin-left: 60px;

  @media (max-width: 980px) {
    margin-left: 58px;
  }

  @media (max-width: 920px) {
    margin: 12px 0 16px;
  }
`;

export const SocialItem = styled.a`
  &:not(:last-child) {
    margin-right: 12px;
  }

  .icon {
    font-size: 28px;
  }
`;

export const LeftColumn = styled.div`
  @media (min-width: 921px) {
    display: contents;

    ${MenuOuter} {
      grid-column: 2;
      grid-row: 1;
      justify-self: end;
    }

    ${Info} {
      grid-column: 2;
      grid-row: 2;
      justify-self: end;
    }
  }

  @media (max-width: 920px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    gap: 0;
  }
`;

export const RightColumn = styled.div`
  @media (min-width: 921px) {
    display: contents;

    ${TopContent} {
      grid-column: 1;
      grid-row: 1;
    }

    ${Copyright} {
      grid-column: 1;
      grid-row: 2;
      align-self: center;
    }
  }

  @media (max-width: 920px) {
    display: contents;
  }
`;

export const Logo = styled(Link)`
  padding-right: 35px;
  filter: grayscale(1) opacity(0.2);

  img {
    width: var(--theme-palette-logo-width, 90px);
    height: var(--theme-palette-logo-height, 48px);
  }

  @media (max-width: 920px) {
    padding-right: 0;
    padding-bottom: 20px;
    display: none;
  }
`;

export const TopContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 29px;

  @media (max-width: 920px) {
    flex-direction: column;
    margin-bottom: 0;
  }
`;

export const LegalityLink = styled.a`
  display: flex;
  align-items: center;
  margin-right: 35px;

  img {
    width: auto;
    height: 50px;
    object-fit: contain;
  }

  @media (max-width: 920px) {
    display: none;
  }
`;

export const MobileLegalityLink = styled.a`
  display: none;

  @media (max-width: 920px) {
    display: block;
    order: -1;
    margin: 0 0 12px;
    line-height: 0;

    img {
      width: auto;
      height: 44.5px;
    }
  }
`;
